import messageType from '../eums/messageType';
import uuidv1 from 'uuid/v1';

export const message = {
    namespaced: true,

    state: {
        messages: []
    },

    mutations: {
        setMessages(state, messages) {
            state.messages = messages;
        },
        resetState() {
            //Object.assign(state, getDefaultState());
        },
    },

    actions: {

        info({ dispatch }, { title, content, sec }) {
            dispatch('addMessage', { type: messageType.MSG_TYPE_INFO, title, content, sec })
        },

        success({ dispatch }, { title, content, sec }) {
            dispatch('addMessage', { type: messageType.MSG_TYPE_SUCCESS, title, content, sec })
        },

        warning({ dispatch }, { title, content, sec }) {
            dispatch('addMessage', { type: messageType.MSG_TYPE_WARNING, title, content, sec })
        },

        error({ dispatch }, { title, content, sec }) {
            dispatch('addMessage', { type: messageType.MSG_TYPE_ERROR, title, content, sec })
        },

        addMessage({ state, commit, dispatch }, { type, title, content, sec = 10000 }) {

            const id = uuidv1();

            const message = {
                id,
                type,
                title,
                content,
            };

            if (type != messageType.MSG_TYPE_ERROR) {
                setTimeout(() => dispatch('removeMessage', { id }), sec);
            }

            commit('setMessages', state.messages.concat(message));
        },

        removeMessage({ state, commit }, { id }) {
            commit('setMessages', state.messages.filter(msg => msg.id != id));
        }

    }

};